import { useState } from 'react';
import { Link } from 'react-router-dom';
import { videoArticles } from '@/mocks/home';

export default function VideoSection() {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = ['全部视频', '网红黑料', '明星塌房', '每日大赛', '娱乐八卦'];

  return (
    <section className="bg-foreground-950 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <button className="px-3 py-1.5 rounded-full border border-background-50/20 text-background-50/70 text-xs whitespace-nowrap mb-4">
              91吃瓜视频
            </button>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight">
              热门吃瓜视频
              <br />
              精彩不停歇
            </h2>
          </div>
          <div className="flex items-center gap-1.5 flex-wrap">
            {tabs.map((tab, idx) => (
              <button
                key={idx}
                onClick={() => setActiveTab(idx)}
                className={`px-3 py-1.5 rounded-full text-xs whitespace-nowrap transition-all duration-200 ${
                  activeTab === idx
                    ? 'bg-background-50 text-foreground-950 font-medium'
                    : 'text-background-50/50 hover:text-background-50/80 hover:bg-background-50/5'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {videoArticles.map((video) => (
            <Link
              key={video.id}
              to={`/article/mou-dingliu-nanyixing-qianshou-xinren`}
              className="group rounded-2xl overflow-hidden bg-background-50/5 hover:bg-background-50/10 transition-colors duration-300"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-foreground-950/80 text-background-50 text-xs">
                  {video.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-background-50 line-clamp-2 leading-snug mb-2">
                  {video.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-background-50/40">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {video.views}
                  </span>
                  <span>次观看</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/meiri-dasai"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/20 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap"
          >
            观看更多视频
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}